import { applicationDetailsSaga } from 'containers/ApplicationDetailsContainer/redux/applicationDetailsSaga';
import { applicationsSaga } from 'containers/ApplicationsContainer/redux/applicationsSaga';
import { userDetailsSaga } from 'containers/UserDetailsContainer/redux/userDetailsSaga';
import { all } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([applicationsSaga(), applicationDetailsSaga(), userDetailsSaga()]);
}
